module.exports = __webpack_public_path__ + "static/media/Employee_Census_Template.9c4e6e47.xlsx";